<template>
  <div class="table">
    <div class="table_top">
      <div class="table_top_L">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="礼包名称">
            <el-input v-model="formInline.name" placeholder="礼包名称"></el-input>
          </el-form-item>
          <el-form-item label="联赛id">
            <el-select v-model="formInline.contestId" placeholder="联赛id" clearable>
              <el-option v-for="option in tableData1" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="inquire">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="openAddDialog">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :data="tableData"
      width="10%"
      height="100%"
      border
      stripe
      highlight-current-row
      v-loading="listLoading"
      ref="table"
      current-row-key="id"
      row-key="id"
      key="id"
      column-key="id"
      @selection-change="selectionChange"
    >
      <el-table-column prop="contestId" label="联赛id" width="60"></el-table-column>
      <el-table-column prop="name" label="礼包名称"></el-table-column>
      <el-table-column label="礼包图片">
        <template slot-scope="scope">
          <img :src="scope.row.logo" alt="" style="height: 50px; width: auto;" />
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="礼包金额"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <div style="display: flex;">
            <el-button type="success" size="small" style="margin: 0 20px;" @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="del(scope.row.id)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增对话框 -->
    <el-dialog title="新增礼包" :visible.sync="addDialogVisible">
      <el-form :model="newBanner" ref="addForm">
        <el-form-item label="礼包名称" prop="name" required>
          <el-input v-model="newBanner.name"></el-input>
        </el-form-item>

        <el-form-item label="绑定联赛" prop="contestId" required>
          <el-select v-model="newBanner.contestId" placeholder="选择联赛id" clearable>
            <el-option v-for="option in tableData1" :key="option.value" :label="option.label" :value="option.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="礼包图片" prop="logo">
          <div v-loading="isLoading" element-loading-text="正在上传...">
            <img v-if="uploadUrl" :src="uploadUrl" style="height:100px;width:100px;" />
            <input type="file" @change="handleFileChange" ref="fileInput" />
          </div>
        </el-form-item>

        <el-form-item label="礼包金额" prop="amount" required>
          <el-input v-model="newBanner.amount"></el-input>
        </el-form-item>

        <!-- <el-form-item label="跳转链接" prop="amount">
          <el-input v-model="newBanner.amount" placeholder="跳转链接"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBanner">取 消</el-button>
        <el-button type="primary" @click="addNewBanner">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { giftBagList, packDelete, contestListDown, uploadPhoto, packSave, packModify } from '@/api/table'

export default {
  data() {
    return {
      tableData1: [],
      tableData: [],
      listLoading: true,
      form: {
        contestId: '',
        logo: '',
        // amount: '',
        name: ''
      },
      formInline: {
        id: '',
        contestId: '',
        state: ''
      },
      newBanner: {
        // 新增的 Banner 数据
        name: '',
        contestId: '',
        logo: ''
        // amount: ''
      },
      uploadUrl: '',
      isLoading: false,
      uploadHeaders: {
        Authorization: '' // 替换为你的鉴权令牌
      },
      total: 0, // 添加总条数
      addDialogVisible: false, // 控制视频弹窗的显示与隐藏
      videoList: [], // 存储视频列表数据
      previewImage: '', // 用于存储预览图片的 URL
      showPreview: false // 控制预览对话框的显示
    }
  },
  mounted() {
    this.reqData1()
    this.tableData = this.reqData()
    this.listLoading = false
  },
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return

      this.isLoading = true // 开始加载

      // 使用 FileReader 来读取文件并生成预览图
      const fileReader = new FileReader()
      fileReader.onload = temp => {
        this.uploadUrl = temp.target.result
      }
      fileReader.readAsDataURL(file)

      const formData = new FormData()
      formData.append('file', file) // 'file' 为后端接收的字段名

      try {
        const response = await uploadPhoto(formData)
        console.log(response)
        this.newBanner.logo = response.msg
        this.$message.success('图片上传成功！')
      } catch (error) {
        this.$message.error('图片上传失败！')
      } finally {
        this.isLoading = false // 上传完成，结束加载
      }
    },

    openAddDialog() {
      this.addDialogVisible = true // 打开对话框
      this.resetNewBanner() // 重置表单数据
      this.$refs.fileInput.value = null
    },
    edit(row) {
      this.resetNewBanner() // 重置表单数据
      this.addDialogVisible = true // 打开对话框
      if (row.logo) {
        this.uploadUrl = `${row.logo}`
      } else {
        this.$refs.fileInput.value = null
      }
      //
      this.newBanner = row
      if (this.newBanner.logo.includes('https://boyubasketball.oss-cn-shanghai.aliyuncs.com/')) {
        this.newBanner.logo = `${row.logo.split('https://boyubasketball.oss-cn-shanghai.aliyuncs.com/')[1]}`
      } else {
        this.newBanner.logo = `${row.logo}`
      }
    },
    closeBanner() {
      this.addDialogVisible = false
      this.uploadUrl = ''
      this.$refs.fileInput.value = null
    },
    resetNewBanner() {
      this.newBanner = {
        name: '',
        contestId: '',
        logo: '',
        amount: ''
      }
    },
    inquire() {
      this.reqData(1, 10000, {
        name: this.formInline.name,
        state: this.formInline.state,
        contestId: this.formInline.contestId
      })
    },
    inquire1() {
      this.reqData(1, 10000, {
        contestId: this.newBanner.contestId
      })
    },
    selectionChange(selection) {
      this.selectionLength = selection.length
    },
    async addNewBanner() {
      if (this.newBanner.id) {
        // 编辑
        await packModify(this.newBanner)
      } else {
        // 新增
        await packSave(this.newBanner)
      }
      this.addDialogVisible = false
      this.uploadUrl = ''
      this.inquire1()
    },
    // 请求
    reqData(pageNum = 1, pageSize = 10000, query = {}) {
      const params = { pageNum, pageSize, ...query }
      giftBagList(params).then(async res => {
        const promises = res.rows.map(async item => {
          // 根据需要拼接 URL
          item.logo = `https://boyubasketball.oss-cn-shanghai.aliyuncs.com/${item.logo}`
          return item
        })
        this.tableData = await Promise.all(promises)
      })
    },
    reqData1(pageNum = 1, pageSize = 10000, query = {}) {
      const params = { pageNum, pageSize, ...query }
      contestListDown(params).then(res => {
        this.tableData1 = res.data.map(item => ({
          value: item.id,
          label: item.name // 假设 id 是数字类型
        }))
      })
    },
    async del(id) {
      try {
        await packDelete(id)
        this.inquire()
      } catch (e) {
        alert('删除失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  display: flex;
  flex-flow: column;
  box-sizing: border-box;

  .table_top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;

    .table_top_L {
      text-align-last: left;
      flex: 1;
      overflow: hidden;
    }
  }

  .table_bottom {
    margin-top: 10px;
  }

  height: 100%;
}
</style>
<style>
.table .el-table {
  transition: all ease-in-out 0.3s;
}

.table .el-table td,
.table .el-table th {
  text-align: center;
}

.table .el-dialog {
  text-align: left;
}

.table .el-dialog .line {
  text-align: center;
}

.el-image-viewer__close {
  background-color: #fff;
}

/* 重新覆盖原来的样式，原来的样式是.el-drawer获取焦点时的outline */
.el-image-viewer__wrapper:focus {
  outline: none;
}
</style>
